import { readonly, ref } from 'vue';
import { useModal } from '@/Composables/Modal/useModal';

export const QR_CODE_MODAL_ID = 'kite-qrcode-popover';

const targetUrl = ref<string>();

export function useQrCodeModal() {
  const { open } = useModal(QR_CODE_MODAL_ID);

  function openQrModal(url?: string): void {
    targetUrl.value = url;
    open();
  }

  return {
    targetUrl: readonly(targetUrl),
    openQrModal,
  };
}
